import React, { useRef, useCallback, useState, useEffect } from 'react';

import { Form } from '@unform/web';
// import { Container } from './styles';
import { Button, Row, Col } from 'react-bootstrap';
import { useAuth } from '../../../hooks/auth';

import { useToast } from '../../../hooks/toast';
import api from '../../../services/api';
import SelectSync, { IOption } from '../../SelectSync';
import TextArea from '../../TextArea';
import IMotivo from '../../../utils/interface/IMotivo';
import Loading from '../../Loading';
import getResponseErrors from '../../../utils/getResponseErrors';

export interface IDadosCancelamento {
  PagCanUsuCodigo: number;
  PagCanMotCodigo: number;
  PagCanMotivo: string;
  DataAtualizacaoAgenda: string;
  ehDespesa: boolean;
}

type Props = {
  cprCodigo: number;
  ehDespesaOuOutrasReceitas: boolean;
  dataAtualizacaoAgenda: string;
  handleFechar(): void;
};

const CancelaBaixa: React.FC<Props> = ({
  cprCodigo,
  dataAtualizacaoAgenda,
  ehDespesaOuOutrasReceitas,
  handleFechar,
}) => {
  const formRefCancelarBaixa = useRef(null);
  const { user } = useAuth();
  const { addToast } = useToast();

  const [optionsMotivo, setOptionsMotivo] = useState<IOption[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    async function loadOptionsMotivo(): Promise<void> {
      setLoading(true);
      try {
        const response = await api.get<IMotivo[]>(
          `/motivo?MotAtivo=true&MotTipo=5`,
        );

        const options = response.data.map((op: IMotivo) => ({
          value: op.MotCodigo.toString(),
          label: op.MotMotivo,
        }));

        setOptionsMotivo(options);
      } catch (error) {
        const mensagemErro = getResponseErrors(error);
        addToast({
          title: 'Não foi possível carregar motivos',
          type: 'error',
          description: mensagemErro,
        });
      }
      setLoading(false);
    }
    loadOptionsMotivo();
  }, [addToast]);

  const handleCancelar = useCallback(
    async data => {
      const { motivo, observacao } = data;
      if (motivo === '') {
        addToast({
          type: 'error',
          title: 'Selecione o motivo',
        });
        return;
      }
      if (observacao === '') {
        addToast({
          type: 'error',
          title: 'Observação é um campo obrigatório',
        });
        return;
      }
      setLoading(true);
      try {
        const dadosCancelamento: IDadosCancelamento = {
          PagCanUsuCodigo: user.UsuCodigo,
          PagCanMotCodigo: motivo,
          PagCanMotivo: observacao,
          DataAtualizacaoAgenda: dataAtualizacaoAgenda,
          ehDespesa: ehDespesaOuOutrasReceitas,
        };
        await api.put(`/caixa/cancelarbaixa/${cprCodigo}`, dadosCancelamento);
        addToast({
          type: 'success',
          title: 'Baixa cancelada com sucesso',
        });
        handleFechar();
      } catch (error) {
        const mensagemErro = getResponseErrors(error);
        // const statusErro = error?.response?.status;
        // if (statusErro === 403) {
        //   setExibePermissaoAdmin(true);
        //   setMensagemPermissaoAdmin(mensagemErro);
        // }
        addToast({
          type: 'error',
          title: 'Erro ao cancelar baixa',
          description: mensagemErro,
        });
      }
      setLoading(false);
    },
    [
      addToast,
      cprCodigo,
      handleFechar,
      dataAtualizacaoAgenda,
      user.UsuCodigo,
      ehDespesaOuOutrasReceitas,
    ],
  );

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const handleOnChangeVazio = useCallback(() => {}, []);

  return (
    <>
      {loading && <Loading backgroundBlack={false} />}
      <Form ref={formRefCancelarBaixa} onSubmit={handleCancelar}>
        <p className="mb-2 mt-0">
          Para realizar esse procedimento insira o motivo e uma observação sobre
          o cancelamento.
        </p>
        <Row className="no-gutters">
          <Col md="12" lg="12" className="form-group pr-2">
            <SelectSync
              name="motivo"
              label="Motivo"
              placeholder="Selecione"
              isClearable={false}
              handleSelectChange={handleOnChangeVazio}
              options={optionsMotivo || [{ label: '', value: '' }]}
            />
          </Col>
        </Row>
        <Row className="no-gutters">
          <Col md="12" lg="12" className="form-group pr-2">
            <TextArea name="observacao" label="Observação" rows={3} />
          </Col>
        </Row>
        <div className="d-flex justify-content-end">
          <Button type="submit" className="mt-2" size="sm">
            Salvar Cancelamento
          </Button>
        </div>
      </Form>
    </>
  );
};

export default CancelaBaixa;
